import SalesManages from '@/pages/accountManage/salesManages'

export default [
  {
    path: '/salesManages',
    name: 'SalesManages',
    component: SalesManages,
    meta: { name: '直销账号' }
  }
]



// WEBPACK FOOTER //
// ./src/router/accountManage/salesManages.js